var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrainings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.3335 17.4724C43.6068 16.3379 41.5767 15.7324 39.5 15.7324C36.7152 15.7324 34.0445 16.8202 32.0754 18.7564C30.1062 20.6926 29 23.3186 29 26.0568C29 28.0988 29.6158 30.0949 30.7696 31.7928C31.9233 33.4906 33.5632 34.8139 35.4818 35.5954C37.4004 36.3768 39.5116 36.5813 41.5484 36.1829C43.5852 35.7845 45.4562 34.8012 46.9246 33.3573C48.3931 31.9134 49.3931 30.0738 49.7982 28.071C50.2034 26.0683 49.9955 23.9924 49.2007 22.1059C48.406 20.2193 47.0602 18.6069 45.3335 17.4724Z",
    fill: "#256BE4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2598 46.6992C39.6357 46.6992 40.0065 46.7856 40.3427 46.9515L46.5195 50V40.3145C44.251 41.377 41.7711 41.9282 39.2598 41.9282C36.7484 41.9282 34.2685 41.377 32 40.3145V50L38.1768 46.9515C38.513 46.7856 38.8838 46.6992 39.2598 46.6992Z",
    fill: "#256BE4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.83984 0H47V4.77268H4.83984V42.9541H24V47.7268H4.83984C3.55623 47.7268 2.3252 47.224 1.41755 46.3289C0.50991 45.4339 0 44.2199 0 42.9541V4.77268C0 3.50689 0.50991 2.29294 1.41755 1.39789C2.3252 0.502834 3.55623 0 4.83984 0Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4142 28.8745C24.7893 28.4749 25 27.933 25 27.368C25 26.803 24.7893 26.2611 24.4142 25.8616C24.0391 25.462 23.5304 25.2376 23 25.2376H13C12.4696 25.2376 11.9609 25.462 11.5858 25.8616C11.2107 26.2611 11 26.803 11 27.368C11 27.933 11.2107 28.4749 11.5858 28.8745C11.9609 29.274 12.4696 29.4984 13 29.4984H23C23.5304 29.4984 24.0391 29.274 24.4142 28.8745Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4142 20.3527C24.7893 19.9532 25 19.4113 25 18.8463C25 18.2812 24.7893 17.7393 24.4142 17.3398C24.0391 16.9403 23.5304 16.7158 23 16.7158H13C12.4696 16.7158 11.9609 16.9403 11.5858 17.3398C11.2107 17.7393 11 18.2812 11 18.8463C11 19.4113 11.2107 19.9532 11.5858 20.3527C11.9609 20.7522 12.4696 20.9767 13 20.9767H23C23.5304 20.9767 24.0391 20.7522 24.4142 20.3527Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainings);
export default __webpack_public_path__ + "static/media/trainings.9d7f4bda7dc1d4f8863aa5ef1360d979.svg";
export { ForwardRef as ReactComponent };